<template>
    <div>
        <!-- Onboarding Banner 1 -->
        <b-alert
            v-if="tab.onboarding_banner_1 === 0 && showNextBanner"
            show
            variant="info"
            dismissible
            @dismissed="dismissAndDelay('1')"
        >
            <p>
                <strong>Auto-Generate Roadmap Items</strong><br>
                Quickly fill your roadmap by creating multiple posts using AI. Keep your roadmap up to date with minimal effort.
            </p>
            <b-button @click="generateRoadmapPosts(); setOnboardingDone('1')" variant="primary">
                Generate Roadmap Posts
            </b-button>
            <b-button @click="dismissAndDelay('1')" variant="link" class="text-muted">
                Skip <b-icon icon="arrow-right"></b-icon>
            </b-button>
        </b-alert>

        <!-- Onboarding Banner 2 -->
        <b-alert
            v-else-if="tab.onboarding_banner_2 === 0 && showNextBanner"
            show
            variant="warning"
            dismissible
            @dismissed="dismissAndDelay('2')"
        >
            <p>
                <strong>Customize Roadmap Layout</strong><br>
                Organize your roadmap easily. Add columns like quarters or now/next/later to match your workflow.
            </p>
            <b-button @click="addColumn(); setOnboardingDone('2')" variant="primary">Add Column</b-button>
            <b-button @click="done(); setOnboardingDone('2')" variant="primary">Done</b-button>
            <b-button @click="dismissAndDelay('2')" variant="link" class="text-muted">
                Skip <b-icon icon="arrow-right"></b-icon>
            </b-button>
        </b-alert>

        <!-- Onboarding Banner 3 -->
        <b-alert
            v-else-if="tab.onboarding_banner_3 === 0 && showNextBanner"
            show
            variant="success"
            dismissible
            @dismissed="dismissAndDelay('3')"
        >
            <p>
                <strong>Move Feedback to Roadmap</strong><br>
                Easily turn feedback into roadmap items. Update a post's status to move it from feedback to the roadmap.
            </p>
            <b-button @click="confirm(); setOnboardingDone('3')" variant="primary">OK</b-button>
        </b-alert>
    </div>
</template>

<script>
export default {
    props: {
        tab: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showNextBanner: true,
            nextBannerDelay: 5000,
        };
    },
    methods: {
        dismissAndDelay(key) {
            this.$set(this.tab, `onboarding_banner_${key}`, -1);
            this.$emit('onboarding-dismissed', `onboarding_banner_${key}`);
            this.showNextBanner = false;
            setTimeout(() => {
                this.showNextBanner = true;
            }, this.nextBannerDelay);
        },
        setOnboardingDone(key) {
            this.$set(this.tab, `onboarding_banner_${key}`, 1);
            this.$emit('onboarding-done', `onboarding_banner_${key}`);
            this.showNextBanner = false;
            setTimeout(() => {
                this.showNextBanner = true;
            }, this.nextBannerDelay);
        },
        generateRoadmapPosts() {
            this.$emit('generate-roadmap-posts');
        },
        addColumn() {
            this.$emit('add-column');
        },
        done() {
            this.$emit('done');
        },
        confirm() {
            this.$emit('confirm');
        },
    },
};
</script>
